export default "__VITE_ASSET__mQS3Wjcn__"